import { Peer } from "peerjs";

// let status = 'home'; // home/challenge-created-waiting-to-accept/playing-match/match-over
// let state = {
//     status: 'home'
// }

// let state = 'home';
let peer;
let conn;

export function logBrokerConnectionStatus() {
  if (peer instanceof Peer) {
    if (peer.disconnected) {
      console.log('not connected to broker server');
    } else {
      console.log('connected to broker server');
    }
  }
}

export function initializePeerAndAttachHandlers() {
  peer = new Peer();
  peer.on('open', peerEventHandlers.open);
  peer.on('connection', peerEventHandlers.connection);
  peer.on('call', peerEventHandlers.call);
  peer.on('close', peerEventHandlers.close);
  peer.on('disconnected', peerEventHandlers.disconnected);
  peer.on('error', peerEventHandlers.error);
}

export function attachPeerHandlers() {
  if (peer instanceof Peer) {
    peer.on('open', peerEventHandlers.open);
    peer.on('connection', peerEventHandlers.connection);
    peer.on('call', peerEventHandlers.call);
    peer.on('close', peerEventHandlers.close);
    peer.on('disconnected', peerEventHandlers.disconnected);
    peer.on('error', peerEventHandlers.error);
  }
}

export function resetPeerHandlers() {
  peerEventHandlers.open = () => { };
  peerEventHandlers.connection = () => { };
  peerEventHandlers.call = () => { };
  peerEventHandlers.close = () => { };
  peerEventHandlers.disconnected = () => { };
  peerEventHandlers.error = () => { };
}

export function disconnectPeer() {
  if (peer instanceof Peer) {
    peer.disconnect();
    console.log('peer server disconnected');
  } else {
    console.log('disconnectPeer: error, peer not in instance of Peer');
  }
}

export function destroyPeer() {
  if (peer instanceof Peer) {
    peer.destroy();
    console.log('peer destroyed');
  } else {
    console.log('destroyPeer: error, peer not in instance of Peer');
  }
}

export function setConnnectionHandler(handler) {
  conn = handler;
}

export function connectToPeerAndAttachHandlers(peerId) {
  if (peer instanceof Peer) {
    console.log(`trying to establish connection to ${peerId}`);
    conn = peer.connect(peerId);
    conn.on('data', connEventHandlers.data);
    conn.on('open', connEventHandlers.open);
    conn.on('close', connEventHandlers.close);
    conn.on('error', connEventHandlers.error);
  } else {
    console.log('not instance of peer');
  }
}

export function attachDataConnectionHandlers() {
  if (conn.peer) {
    conn.on('data', connEventHandlers.data);
    conn.on('open', connEventHandlers.open);
    conn.on('close', connEventHandlers.close);
    conn.on('error', connEventHandlers.error);
  }
}

export function resetConnHandlers() {
  connEventHandlers.data = () => { };
  connEventHandlers.open = () => { };
  connEventHandlers.close = () => { };
  connEventHandlers.error = () => { };
}

export function sendMessage(data) {
  if (conn.peer) {
    conn.send(data);
  }
}

// export function initializePeer() {
//     peer = new Peer();
//     peer.on('open', function (id) {
//         // console.log('My peer ID is: ' + id);
//         goToChallengeLink({ link: `${variant}/${id}` })
//         // state = 'challenge created';
//     });
//     peer.on('connection', function (dataConnection) {
//         // logic when someone connects
//     });
//     peer.on('call', function (mediaConnection) {
//         // logic when someone calls
//     });
//     peer.on('close', function () {
//         // logic when peer is destroyed
//     });
//     peer.on('disconnected', function () {
//         // logic when disconnects from signalling server, can try to reconnect
//     });
//     peer.on('error', function (err) {
//         console.log(err.type);
//         console.log(err.message);
//         displayPopMessage(`Error: ${err.type}`);
//         displayPopMessage(`Error: ${err.message}`);
//     });
// }

// some connection object
function onMessage(message) {
  // this will receive any message from the connected peer and take actions accordingly
}

// HOME

// export function createChallengeLink(variant) { // variant == simple / ultimate
//     if (state != 'home') {
//         console.log(`warning: createChallengeLink() called from ${state}, state`);
//         return;
//     }
//     peer = new Peer();
//     peer.on('open', function (id) {
//         // console.log('My peer ID is: ' + id);
//         goToChallengeLink({ link: `${variant}/${id}` })
//         state = 'challenge created';
//     });
//     peer.on('connection', function (dataConnection) {
//         // logic when someone connects
//     });
//     peer.on('call', function (mediaConnection) {
//         // logic when someone calls
//     });
//     peer.on('close', function () {
//         // logic when peer is destroyed
//     });
//     peer.on('disconnected', function () {
//         // logic when disconnects from signalling server, can try to reconnect
//     });
//     peer.on('error', function (err) {
//         console.log(err.type);
//     });
// }

// CHALLANGE CREATED

function challengeGotAccepted(params) {

}

// export function cancelChallenge(params) {
//     if (state != 'challenge created') {
//         console.log(`warning: cancelChallenge() called from ${state}, state`);
//         return;
//     }
//     peer.destroy();
//     state = 'home';
// }

// // TRY TO ACCEPT CHALLANGE

// export function tryToAcceptChallenge(peerId) {
//     if (state != 'home') {
//         console.log(`warning: tryToAcceptChallenge() called from ${state}, state`);
//         return;
//     }
//     // try to connect to peer
//     console.log('trying to connect to peer to accept challenge')
//     peer = new Peer();
//     peer.on('open', function (id) {
//         console.log('My peer ID is: ' + id);
//         conn = peer.connect(peerId);
//         conn.on('open', function () {

//             // connection established.
//             console.log('established data channel with peer');

//             // Receive messages
//             conn.on('data', function (data) {
//                 console.log('Received', data);
//             });

//             // Send messages
//             conn.send('Hello!');
//         });
//     });
//     peer.on('error', function (err) {
//         // connection established.
//         console.log(`could not connect to any peer with the given id ${peerId}`);
//         console.log(err.type);
//     });
// }

// PLAYING MATCH

let ongoingMatch; // it will have state of match (can be simple/ultimate)

function makeMove(params) {

}

function resign(params) {

}

// MATCH OVER

function goBackToHome(params) {

}

// export let messageHandlers = {
//   YOUR_CHALLENGE_CREATED: null,
//   // YOUR_LINK_INFO: null,
// }

export let peerEventHandlers = {
  open: () => { },
  connection: () => { },
  call: () => { },
  close: () => { },
  disconnected: () => { },
  error: () => { },
};

export let connEventHandlers = {
  data: () => { },
  open: () => { },
  close: () => { },
  error: () => { },
};